import { render, staticRenderFns } from "./PosrecallBill.vue?vue&type=template&id=1be2ff72&scoped=true&"
import script from "./PosrecallBill.vue?vue&type=script&lang=js&"
export * from "./PosrecallBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be2ff72",
  null
  
)

export default component.exports